import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import { ref, set } from 'firebase/database';
import { database, DB_PATHS } from '../config/firebase';

interface Manager {
  phonenumber: string;
  username: string;
  password: string;
  grade: string;
  appname: string;
  block: string;
  initdate: string;
  referralcode: string;
  // 충청 앱 추가 필드들
  registrant?: string; // 등록자 전번 필드
  registeredBy?: string;
  extensionAmount?: number;
  fee?: number;
}

interface ChungcheongManagerEditProps {
  open: boolean;
  onClose: () => void;
  manager: Manager | null;
  onSave: (updatedManager: Manager) => void;
}

const ChungcheongManagerEdit: React.FC<ChungcheongManagerEditProps> = ({
  open,
  onClose,
  manager,
  onSave,
}) => {
  const [editManager, setEditManager] = useState<Manager | null>(null);

  // 다이얼로그 열릴 때 초기화
  useEffect(() => {
    if (open && manager) {
      setEditManager({ ...manager });
    }
  }, [open, manager]);

  const handleSave = async () => {
    if (!editManager) return;

    try {
      await set(ref(database, `${DB_PATHS.MANAGER}/${editManager.phonenumber}`), editManager);
      onSave(editManager);
      onClose();
      alert('관리자 정보가 성공적으로 수정되었습니다.');
    } catch (error) {
      console.error('관리자 수정 실패:', error);
      alert('관리자 수정에 실패했습니다.');
    }
  };

  const handleClose = () => {
    setEditManager(null);
    onClose();
  };

  if (!editManager) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>관리자 정보 수정</DialogTitle>
      <DialogContent>
        <TextField
          label="전화번호"
          value={editManager.phonenumber}
          onChange={e => setEditManager({ ...editManager, phonenumber: e.target.value })}
          fullWidth
          margin="dense"
          disabled
        />
        <TextField
          label="이름"
          value={editManager.username}
          onChange={e => setEditManager({ ...editManager, username: e.target.value })}
          fullWidth
          margin="dense"
        />
        <TextField
          label="비밀번호"
          type="text"
          value={editManager.password}
          onChange={e => setEditManager({ ...editManager, password: e.target.value })}
          fullWidth
          margin="dense"
        />
        
        {/* 권한 고정 표시 */}
        <TextField
          label="권한"
          value="localmanager"
          InputProps={{
            readOnly: true,
          }}
          fullWidth
          margin="dense"
        />
        
        {/* 등록자 전번 필드 */}
        <TextField
          label="등록자 전번"
          value={editManager.registrant || ''}
          onChange={e => setEditManager({ ...editManager, registrant: e.target.value })}
          fullWidth
          margin="dense"
          placeholder="등록자 전화번호"
        />
        
        {/* 연장금액 필드 */}
        <TextField
          label="연장금액"
          type="number"
          value={editManager.extensionAmount || 20000}
          onChange={e => {
            const value = e.target.value;
            const numValue = value ? Math.floor(Number(value)) : 20000;
            setEditManager({ ...editManager, extensionAmount: numValue });
          }}
          fullWidth
          margin="dense"
          placeholder="연장금액 (20,000원 ~ 90,000원)"
          inputProps={{
            min: 20000,
            max: 90000,
            step: 1000,
          }}
          helperText="20,000원 ~ 90,000원 사이로 입력하세요"
        />
        
        <TextField
          label="추천코드"
          value={editManager.referralcode}
          onChange={e => setEditManager({ ...editManager, referralcode: e.target.value })}
          fullWidth
          margin="dense"
        />
        
        <FormControl fullWidth margin="dense">
          <InputLabel>차단</InputLabel>
          <Select
            value={editManager.block}
            label="차단"
            onChange={e => setEditManager({ ...editManager, block: e.target.value })}
          >
            <MenuItem value="false">false</MenuItem>
            <MenuItem value="true">true</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>취소</Button>
        <Button onClick={handleSave} variant="contained">
          저장
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChungcheongManagerEdit; 